import React, { Component } from "react";
import Edit from "../assets/edit.svg";
import Deletee from "../assets/delete.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default class UsersEditButton extends Component {
  render() {
    return (
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 200, hide: 200 }}
          overlay={
            <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
              ویرایش
            </Tooltip>
          }
        >
          <div
            style={{ cursor: "pointer", userSelect: "none" }}
            onClick={() => this.props.editItem(this.props.value)}
          >
            <img
              src={Edit}
              alt=""
              style={{
                objectFit: "contain",
                height: this.props.height ? this.props.height : "20px",
              }}
            />
          </div>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 200, hide: 200 }}
          overlay={
            <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
              حذف
            </Tooltip>
          }
        >
          <div
            style={{
              cursor: "pointer",
              userSelect: "none",
              marginRight: "20px",
            }}
            onClick={() => this.props.deleteItem(this.props.value)}
          >
            <img
              src={Deletee}
              alt=""
              style={{
                objectFit: "contain",
                height: this.props.height ? this.props.height : "23px",
              }}
            />
          </div>
        </OverlayTrigger>
      </div>
    );
  }
}
